<template>
  <el-card
      shadow="never"
      style="border-radius: 4px !important; border: 1px solid #dee5ec;"
      body-style="margin: 0px;">
    <div>
      <div
          class="flex flex-row"
          style="margin: 8px 24px 8px 8px">
        <img
            v-if="devicePicture && devicePicture.src"
            style="width: 80px; height: 80px"
            :alt="devicePicture.alt"
            :src="devicePicture.src">
        <div
            class="flex-1"
            style="margin: 8px">
          <div class="flex flex-row">
            <div class="item-name flex-1">
              {{ title }}
            </div>
            <div
                v-if="quantity>1"
                class="flex-1"
                style="margin-top: 15px;">
              x{{ quantity }}
            </div>
            <div
                v-if="!subItem"
                class="item-price">
              {{ formattedAmount }}
            </div>
          </div>
          <div class="item-sku">
            <strong>ASIN: </strong>&nbsp;{{ sku }}
          </div>
          <div
              v-if="variantTitle!=='bundle'"
              class="item-status"
              :class="'item-status-'+status.replace(' ','-').toLowerCase()">
            {{ status }}
          </div>
        </div>
      </div>
      <div
          v-if="quantity>1 || variantTitle==='bundle'"
          style="margin-left: 96px; margin-right: 24px">
        <el-button
            v-if="expandBundle"
            type="text"
            @click="expandBundle=false;">
          <span class="show-button">
            Show less
          </span>
        </el-button>
        <el-button
            v-else
            type="text"
            @click="expandBundle=true;">
          <span class="show-button">
            Show more
          </span>
        </el-button>
        <div v-if="expandBundle">
          <order-details-item-view
              v-for="(item, idx) in items"
              :key="idx"
              v-bind="item"
              :sub-item="true"
              style="margin-bottom: 8px" />
        </div>
      </div>
    </div>
  </el-card>
</template>
<script>
import numeral from "numeral";

export default {
  name: "OrderDetailsItemView",
  props: {
    title: {
      type: String,
      default: "NA",
    },
    variantTitle: {
      type: String,
      default: "doorbell",
    },
    sku: {
      type: String,
      default: "NA",
    },
    status: {
      type: String,
      default: "Pending",
    },
    preTaxPrice: {
      type: Object,
      default: () => {
        return {
          amount: 0,
          currency_code: "USD",
        };
      },
    },
    images: {
      type: Array,
      default: () => {
        return [];
      },
    },
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    subItem: {
      type: Boolean,
      default: false,
    },
    quantity: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      currencySymbols: {
        EUR: "€",
        NONE: "",
        USD: "$",
        GBP: "£",
        AUD: "A$",
        NZD: "N$",
        CAD: "C$",
      },
      expandBundle: false,
    };
  },
  computed: {
    formattedAmount() {
      var amount = numeral(this.preTaxPrice.amount).format(`0,0.00`);
      return `${this.currencySymbols[this.preTaxPrice.currency_code]}${amount}`;
    },
    devicePicture() {
      return this.images[0];
    },
  },
};
</script>

<style>
.item-name {
  height: 24px;
  font-family: "Equip", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #424242;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.item-sku {
  height: 24px;
  font-family: "Equip", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  align-items: flex-end;
  color: #6e6e6e;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
  margin-top: 2px;
}

.item-status {
  height: 24px;
  font-family: "Equip", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  flex: none;
  order: 1;
  flex-grow: 1;
  margin-top: 14px;
  color: #f1670d;
}

.item-status-shipped {
  color: #178019 !important;
}

.item-status-pending {
  color: #f1670d !important;
}

.item-status-cancelled {
  color: #d4231a !important;
}

.item-price {
  height: 24px;
  font-family: "Equip", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-align: right;
  color: #424242;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.show-button {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  text-decoration-line: underline;
  color: #10628a;
}
</style>
